document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.mobile-menu-accordion');

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      const contentInner = entry.target;
      const content = contentInner.parentElement;
      if (content.style.maxHeight && content.style.maxHeight !== '0px') {
        requestAnimationFrame(() => {
          content.style.maxHeight = contentInner.scrollHeight + 'px';
        });
      }
    }
  });

  accordions.forEach(accordion => {
    const trigger = accordion.querySelector('.mobile-menu-accordion__trigger');
    const content = accordion.querySelector('.mobile-menu-accordion__content');
    const contentInner = accordion.querySelector('.mobile-menu-accordion__content-inner');

    resizeObserver.observe(contentInner);

    if (accordion.classList.contains('is-open')) {
      content.style.maxHeight = contentInner.scrollHeight + 'px';
    }

    trigger.addEventListener('click', () => {
      accordion.classList.toggle('is-open');

      if (content.style.maxHeight && content.style.maxHeight !== '0px') {
        content.style.maxHeight = '0px';
      } else {
        content.style.maxHeight = contentInner.scrollHeight + 'px';
      }
    });
  });
});
